import { configureStore } from '@reduxjs/toolkit'
import { reducer as userInfoReducer } from './user-info'
import { reducer as guildInfoReducer } from './guild-info'
import { reducer as countryList } from './country'
import { reducer as withdrawInfoReducer } from './withdraw-info'
import { reducer as globalSettingsReducer } from './global-settings'

export const store = configureStore({
  reducer: {
    userInfo: userInfoReducer,
    guildInfo: guildInfoReducer,
    countryList: countryList,
    withdrawInfo: withdrawInfoReducer,
    globalSettings: globalSettingsReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
